var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("main", [
    _c(
      "div",
      { staticClass: "top-banner" },
      [
        _c("el-image", {
          staticClass: "institution-logo",
          attrs: { src: _vm.schoolInfo.logo, fit: "cover" },
        }),
        _c("h1", { on: { click: _vm.goSchool } }, [
          _c("i", { staticClass: "el-icon-mic" }),
          _c("span", [_vm._v(_vm._s(_vm.schoolInfo.live_title))]),
          _c("i", { staticClass: "el-icon-mic" }),
        ]),
      ],
      1
    ),
    _c("div", { staticClass: "container" }, [
      _c("h2", [_vm._v(_vm._s(_vm.liveDetail.title))]),
      _c("div", { staticClass: "broadcast-info" }, [
        _c("div", { staticClass: "info-item" }, [
          _c("label", [_vm._v("直播时间: ")]),
          _c("span", [_vm._v(_vm._s(_vm.liveDetail.live_time))]),
        ]),
        _c("div", { staticClass: "info-item" }, [
          _c("label", [_vm._v("主讲人: ")]),
          _c("span", [_vm._v(_vm._s(_vm.liveDetail.teacher))]),
        ]),
      ]),
      _c("div", { staticClass: "viewers" }, [
        _c("i", { staticClass: "el-icon-view" }),
        _c("span", [_vm._v(_vm._s(_vm.liveDetail.view_count))]),
      ]),
      _c(
        "div",
        { staticClass: "video-container" },
        [
          _vm.liveDetail.status == 1 && _vm.liveDetail.review_url
            ? _c("iframe", {
                staticStyle: { width: "100%", height: "100%" },
                attrs: { src: _vm.liveDetail.review_url, frameborder: "0" },
              })
            : _vm.liveDetail.status == 3
            ? _c(
                "a",
                {
                  staticClass: "view_box",
                  attrs: { href: _vm.liveDetail.live_url },
                },
                [
                  _c("div", { staticClass: "play" }),
                  _c("el-image", {
                    staticClass: "video-cover",
                    attrs: { src: _vm.liveDetail.live_cover },
                  }),
                ],
                1
              )
            : _c("el-image", {
                staticClass: "video-cover",
                attrs: { src: _vm.liveDetail.live_cover },
              }),
        ],
        1
      ),
    ]),
    _vm._m(0),
    _c("div", { staticClass: "broadcast-introduce" }, [
      _c("div", { domProps: { innerHTML: _vm._s(_vm.liveDetail.content) } }),
    ]),
    _c("div", { staticClass: "swiper-box" }, [
      _c("i", {
        staticClass: "el-icon-arrow-left before-arrow",
        attrs: { disabled: _vm.step >= 0 },
        on: {
          click: function ($event) {
            return _vm.prePage()
          },
        },
      }),
      _c("div", { staticClass: "swiper-display" }, [
        _c(
          "ul",
          { ref: "animationRef", staticClass: "experience-container" },
          _vm._l(_vm.recommendLiveList, function (item) {
            return _c(
              "li",
              { key: item.id },
              [_c("ListCard", { attrs: { "card-data": item } })],
              1
            )
          }),
          0
        ),
      ]),
      _c("i", {
        staticClass: "el-icon-arrow-right after-arrow",
        attrs: { disabled: _vm.step <= -(_vm.recommendLiveList.length - 3) },
        on: {
          click: function ($event) {
            return _vm.nextPage()
          },
        },
      }),
    ]),
    _c("div", { staticClass: "bottom-banner" }, [
      _c("span", [
        _vm._v(
          "版权所有©" + _vm._s(_vm.schoolInfo.name) + " 斯奈特提供在线技术支持"
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "middle-banner" }, [
      _c("span", { staticClass: "background-text" }, [
        _vm._v("LIVE BROADCAST"),
      ]),
      _c("h3", [_vm._v("直播介绍")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }